import { FormRegExp } from '../../constants/FormRegExp';

export const preparePriceFormat = (price, isPence) => {
  if (typeof price !== 'number' || Number.isNaN(price)) return '';

  let str;
  if (isPence) {
    // convert pence to pounds with up to two decimals, then trim trailing zeros
    const s = (price / 100).toFixed(2);
    str = s.replace(/\.00$/, '').replace(/\.(\d)0$/, '.$1');
  } else {
    // price is already pounds (may be integer); convert to string as-is
    str = price.toString();
  }

  // add thousands separators using the existing regex
  return `£${str.replace(FormRegExp.PRICE, ',')}`;
};
